import styled from 'styled-components'

import { PageType } from '@/enums'

export const Wrapper = styled.div`
	height: 3.438rem;
	display: flex;
	align-content: flex-end;
	flex-wrap: wrap;
`
export const CustomAttributesSwitcherWrap = styled.div<{
	$pageType: PageType | undefined
}>`
	width: 100%;
	margin-bottom: ${({ $pageType }) =>
		$pageType === PageType.OVERVIEW_PAGE ? '0' : '1rem'};
`
